import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgEyeClosedIconSecondary(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.652 3.532a.75.75 0 0 0-1.435.437c.162.533.384 1.04.66 1.512L.22 7.133a.75.75 0 1 0 1.06 1.062l1.494-1.49c.415.454.888.854 1.409 1.187L3.059 9.86a.75.75 0 0 0 1.303.744l1.167-2.045a6.96 6.96 0 0 0 1.575.378v2.292a.75.75 0 0 0 1.5 0V8.958a6.972 6.972 0 0 0 1.692-.369l1.15 2.015a.75.75 0 0 0 1.303-.744L11.65 7.937a7.053 7.053 0 0 0 1.528-1.284l1.546 1.542a.75.75 0 1 0 1.06-1.062L14.066 5.42c.258-.455.468-.94.624-1.45a.75.75 0 1 0-1.435-.437 5.592 5.592 0 0 1-2.87 3.394.755.755 0 0 0-.169.08 5.498 5.498 0 0 1-2.263.482c-2.516 0-4.604-1.664-5.301-3.956Z",
    fill: "currentColor"
  }), '\xCE');
}

export { SvgEyeClosedIconSecondary as default };
